/** Filters rendered as a date-range picker: no values to fetch and no search input. */
export enum DateFilterEnum {
  CONTRACT_START_DATE = "contract_start_date",
  CONTRACT_END_DATE = "contract_end_date",
  SESSION_START_DATE = "session_start_date",
  SESSION_END_DATE = "session_end_date",
}

/** Widened to string so a raw `filterId` can be tested with `.includes()`. */
export const DATE_FILTER_IDS: readonly string[] = Object.values(DateFilterEnum);
